<template>
  <div class="container-fluid">
    <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body px-3 pt-0 pb-2 min-vh-50">
              <form id="search" class="mt-3" @submit.prevent="getKanban">
                <div class="row g-2 d-flex justify-content-end">
                  <div class="col-12 col-sm">
                    <label class="text-xxs font-weight-normal text-secondary" for="name">Kanban Number</label>
                    <div class="input-group input-group-sm">
                      <span class="input-group-text" id="basic-addon1">
                        <i class="fa fa-search"></i>
                      </span>
                      <input 
                        v-model="search.number" 
                        type="text" 
                        class="form-control" 
                        placeholder="Kanban Number" 
                        aria-label="Kanban Number" 
                        aria-describedby="basic-addon1">
                    </div>
                  </div>
                  <div class="col-12 col-sm-3">
                    <label class="text-xxs font-weight-normal text-secondary" for="name">Delivery Date</label>
                    <Datepicker 
                      v-model="search.delivery_date" 
                      range
                      format="dd MMM yyyy"/>
                  </div>
                  <div class="col-12 col-sm-3">
                    <label class="text-xxs font-weight-normal text-secondary" for="name">Expected Date</label>
                    <Datepicker 
                      v-model="search.expected_date" 
                      range
                      format="dd/MM/yyyy"/>
                  </div>
                  <div class="col-12 col-sm-2">
                    <label class="text-xxs font-weight-normal text-secondary" for="name">Status</label>
                    <div class="input-group input-group-sm">
                      <span class="input-group-text" id="basic-addon1">
                        <i class="fa fa-search"></i>
                      </span>
                      <select v-model="search.state" class="form-select form-select-sm" >
                        <option v-for="(value, key) in statusOptions" :key="key" :value="key">{{ value }}</option>
                      </select>
                    </div>
                    
                  </div>
                  <!-- <div class="col-12 col-sm-1 align-self-end">
                    <button type="submit" class="btn btn-sm btn-primary mb-0">
                      <i class="fa fa-search"></i>
                    </button>
                  </div> -->
                  <div class="col-12 col-sm-2 align-self-top pt-4">
                    <button type="submit" class="btn btn-primary mb-0 justify-content-center" style="width: 50px;" @click="resetOffset">
                      <i class="fa fa-search"></i>
                    </button>

                    <!-- Adding margin to create space -->
                    <button class="btn btn-primary mb-0 justify-content-center" style="width: 50px; margin-left: 5px;" @click="clearSearch">
                      <i class="fa fa-times-circle"></i>
                    </button>

                  </div>
                </div>
              </form>
              <hr class="my-2"/>
              <div class="d-flex">
                <div class="d-flex d-grid gap-2 col-6">
                  <button class="btn btn-xs btn-outline-primary" @click="download"><i class="fa fa-download"></i> Download From PDF</button>
                  <button class="btn btn-xs btn-outline-primary" @click="downloadXlsx"><i class="fa fa-download"></i> Download From XLSX</button>
                </div>
                <div class="d-flex col-6 justify-content-end">
                  <p class="align-self-center text-xs text-secondary">{{ current_page }} - {{ current_total_data }} / {{ total_data }}</p>
                  <argon-pagination color="gradient-primary" size="sm">
                    <argon-pagination-item
                      @click="prevPage"
                      prev
                      :disabled="offset === 0 ? true : false" />
                    <argon-pagination-item
                      @click="nextPage"
                      next
                      :disabled="record_more === false ? true : false" />
                  </argon-pagination>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table align-items-center">
                  <thead>
                      <tr class="bg-light">
                           <th class="ps-2" width="2%">
                              <input type="checkbox" v-model="selectAll">
                          </th>
                          <th class="text-uppercase text-xxs font-weight-bolder ps-2">DN Number</th>
                          <th class="text-uppercase text-xxs font-weight-bolder ps-2">Purchase Number</th>
                          <th class="text-uppercase text-xxs font-weight-bolder ps-2">Total Kanban</th>
                          <th class="text-uppercase text-xxs font-weight-bolder ps-2">Delivery Date</th>
                          <th class="text-uppercase text-xxs font-weight-bolder ps-2">Delivery Time</th>
                          <!-- <th class="text-uppercase text-xxs font-weight-bolder ps-2">Expected Date</th>
                          <th class="text-uppercase text-xxs font-weight-bolder ps-2">Shop</th> -->
                          <th class="text-uppercase text-xxs font-weight-bolder ps-2">Customer</th>
                          <th class="text-uppercase text-xxs font-weight-bolder ps-2">Status</th>
                          <th class="text-uppercase text-xxs font-weight-bolder ps-2">Cycle Time</th>
                          <th class="text-uppercase text-xxs font-weight-bolder ps-2">Projects</th>
                          <th class="text-uppercase text-xxs font-weight-bolder ps-2">Transporter</th>
                          <th class="text-uppercase text-xxs font-weight-bolder ps-2">Already Invoiced</th>
                          <!-- <th class="text-uppercase text-xxs font-weight-bolder ps-2">Plant Site</th> -->
                          <!-- <th class="text-uppercase text-xxs font-weight-bolder ps-2">Dock</th> -->
                          
                      </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(line, i) in kanban" :key="i">
                      <td>
                        <input v-model="kanbanSelected" type="checkbox" :value="line.id">
                      </td>
                      <td>
                        <router-link :to="'/kanban/' + line.id" class="text-xs text-primary font-weight-bold mb-0">
                            {{ line.name }}
                        </router-link>
                      </td>
                      <td>
                        <p class="mb-0 text-xs">{{ line.purchase_number }}</p>
                      </td>
                      <td>
                        <p class="mb-0 text-xs">{{ line.total_kanban }}</p>
                      </td>
                      <td>
                        <p class="mb-0 text-xs">{{ line.delivery_date }}</p>
                      </td>
                      <td>
                        <p class="mb-0 text-xs">{{ line.delivery_time }}</p>
                      </td>
                      <!-- <td>
                        <p class="mb-0 text-xs">{{ line.expected_date }}</p>
                      </td>
                      <td>
                        <p class="mb-0 text-xs">{{ line.shop }}</p>
                      </td> -->
                      <td>
                        <p class="text-sm mb-0 pl-1"><argon-badge style="margin-left: 2px;" v-for="customer,i in line.customer_ids" :key="i" 
                          color="secondary"
                          size="sm">{{ customer }}
                        </argon-badge></p>
                      </td>
                      <td>
                        <argon-badge color="info" size="sm">{{ line.state }}</argon-badge>
                      </td>
                      <td>
                        <p class="mb-0 text-xs">{{ line.cycle_name }}</p>
                      </td>
                      <td>
                        <p class="text-sm mb-0 pl-1"><argon-badge style="margin-left: 2px;" v-for="project,i in line.project_name" :key="i" 
                          color="secondary"
                          size="sm">{{ project }}
                        </argon-badge></p>
                      </td>
                      <td>
                        <p class="mb-0 text-xs">{{ line.transporter }}</p>
                      </td>
                      <td>
                        <!-- <input v-model="modal.selected" type="checkbox" :value="dn.id"> -->
                        <input type="checkbox" disabled :checked="line.is_invoiced === true">
                      </td>
                      <!-- <td>
                        <p class="mb-0 text-xs">{{ line.plant_site }}</p>
                      </td>
                      <td>
                        <p class="mb-0 text-xs">{{ line.dock_parking }}</p>
                      </td> -->
                      
                    </tr>
                  </tbody>
                </table>
              </div>
              <empty-state v-if="!kanban.length > 0 && !loading"/>
              <loading-state v-if="loading"/>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import ArgonPagination from "@/components/ArgonPagination.vue";
import ArgonPaginationItem from "@/components/ArgonPaginationItem.vue";
import ArgonBadge from "@/components/ArgonBadge.vue";
import EmptyState from "./components/EmptyState.vue";
import LoadingState from "./components/LoadingState.vue";
const endpoint = require("../router/endpoint");

export default {
  name: 'Kanban',
  components: {
    ArgonPagination,
    ArgonPaginationItem,
    ArgonBadge,
    EmptyState,
    LoadingState
  },
  data() {
    return {
      loading: false,
      total_data: 0,
      current_total_data: 0,
      record_more: false,
      page: 0,
      current_page: 0,
      offset: 0,
      search: {
        number: null,
        delivery_date: null,
        expected_date: null,
        state: null
      },
      kanban: [],
      kanbanSelected: [],
      statusOptions: {
        'confirm': 'Confirmed',
        'done':'Done',
        'invoice_created':'Invoice Created',
        'invoice_cancel':'Invoice Cancel',
        'invoice_done':'Invoice Done',
        'cancel':'Cancel',
      },
    }
  },
  methods: {
    prevPage() {
      if (this.offset > 0) {
          this.offset = this.offset - 10
          this.getKanban()
        }
    },
    nextPage() {
      if (this.record_more === true) {
        this.offset = this.offset + 10
        this.getKanban()
      }
    },
    getDate(daterange) {
      var dateList = []
      if (daterange !== null){
        if (daterange.length > 0) {
          daterange.forEach(date => {
            if (date) {
              let month = date.getMonth() >= 9 ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1)
              let fullDate = date.getFullYear() + '-' + month + '-' + date.getDate()
              dateList.push(fullDate)
            }
          });
        }
      }
      return dateList
    },
    getKanban() {
      this.kanban = []
      this.loading = true
      this.total_data = 0
      this.current_total_data = 0
      this.record_more = false
      this.current_page = 0
      const deliveryDateRange = this.getDate(this.search.delivery_date)
      const expectedDateRange = this.getDate(this.search.expected_date)
      this.axios
        .post(
          endpoint.DN_LIST,
          {
            number: this.search.number,
            partner_id: localStorage.getItem('partner_id'),
            delivery_date_start: deliveryDateRange.length > 0 ? deliveryDateRange[0] : null,
            delivery_date_end: deliveryDateRange.length > 1 ? deliveryDateRange[1] : null,
            expected_date_start: expectedDateRange.length > 0 ? expectedDateRange[0] : null,
            expected_date_end: expectedDateRange.length > 1 ? expectedDateRange[1] : null,
            state : this.search.state != null ? [this.search.state] : null,
            limit: 10,
            offset: this.offset,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then((response) => {
          if (response.data.response_code === "0000") {
            this.kanban = response.data.data;
            this.total_data = response.data.total_data
            this.current_total_data = response.data.current_total_data
            this.record_more = response.data.record_more
            this.current_page = response.data.current_page
          } else if (response.data.reponse_code === "4000") {
            this.$notify({
              type: 'warn',
              title: 'Warning',
              text: response.data.message,
            });
          }
          this.loading = false
        })
        .catch((e) => {
          this.$notify({
              type: 'error',
              title: 'Failed',
              text: e.response.data.message,
            });
          this.loading = false;
        });
    },
    download () {
        if (this.kanbanSelected.length === 0) {
          this.$notify({
                type: 'error',
                title: 'Something went wrong!',
                text: "Select Kanban First .",
                });
        }
        else {

          this.loading = true
          this.axios
              .post(
              endpoint.DOWNLOAD,
              {
                  res_ids: this.kanbanSelected,
                  template_report: 'stock_request.action_report_delivery_notes'
              },
              {
                  headers: {
                  Authorization: `Bearer ${localStorage.getItem("token")}`
                  }
              }
              )
              .then((response) => {
              if (response.data.response_code === "0000") {
                  const linkSource = `data:application/pdf;base64,${response.data.data.file}`;
                  const downloadLink = document.createElement("a");
                  const fileName = "Kanban Form.pdf";
                  downloadLink.href = linkSource;
                  downloadLink.download = fileName;
                  downloadLink.click();
              } else {
                  if (response.data.response_code !== "4000"){
                  this.$notify({
                      type: 'warn',
                      title: 'Warning',
                      text: response.data.message,
                  });
                  }
              }
              this.loading = false
              })
              .catch((e) => {
              this.loading = false;
              this.$notify({
                  type: 'error',
                  title: 'Something went wrong!',
                  text: e.response.data.message,
                  });
              });
          }
        },
    downloadXlsx () {
        if (this.kanbanSelected.length === 0) {
            this.$notify({
                  type: 'error',
                  title: 'Something went wrong!',
                  text: "Select Kanban First .",
                  });
          }
        else {
          this.loading_xlsx = true
          this.axios
              .post(
              endpoint.DOWNLOAD,
              {
                  res_ids: this.kanbanSelected,
                  template_report: 'stock_request.delivery_notes_xlsx'
              },
              {
                  headers: {
                  Authorization: `Bearer ${localStorage.getItem("token")}`
                  }
              }
              )
              .then((response) => {
              if (response.data.response_code === "0000") {
                  const linkSource = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${response.data.data.file}`;
                  const downloadLink = document.createElement("a");
                  const fileName = "Kanban Form.xlsx";
                  downloadLink.href = linkSource;
                  downloadLink.download = fileName;
                  downloadLink.click();
              } else {
                  if (response.data.response_code !== "4000"){
                  this.$notify({
                      type: 'warn',
                      title: 'Warning',
                      text: response.data.message,
                  });
                  }
              }
              this.loading_xlsx = false
              })
              .catch((e) => {
              this.loading_xlsx = false;
              this.$notify({
                  type: 'error',
                  title: 'Something went wrong!',
                  text: e.response.data.message,
                  });
              });
          }
        },
    clearSearch(){
          this.search.number = null;
          this.search.delivery_date = null;
          this.search.expected_date = null;
          this.search.state = null;
    },
    resetOffset(){
      this.offset = 0
    }
  },
  computed: {
    selectAll: {
        get: function () {
          if (this.kanbanSelected.length > 0) {
            return this.kanban ? this.kanbanSelected.length == this.kanban.length : false;
          }
          return false
        },
        set: function (value) {
            var selected = [];

            if (value) {
                this.kanban.forEach(function (kanban) {
                    selected.push(kanban.id);
                });
            }
            this.kanbanSelected = selected;
        }
    }
  },
  mounted() {
    this.getKanban()
  }
}
</script>

<style>

</style>